import React from 'react';
import { FormControl, InputLabel, Select } from '@material-ui/core';

export const ToolbarDropdown = ({ title, value, onChange, onSelect, children, ...props }) => {
  return (
    <FormControl 
      fullWidth 
      variant="outlined" 
      size="small" 
      {...props}
    >
      <InputLabel>{title}</InputLabel>
      <Select 
        native 
        value="" 
        onChange={(e) => {
          const selectedValue = e.target.value;

          if (onChange) {
            onChange(selectedValue);
          }
          
          if (onSelect) {
            onSelect(selectedValue);
          }
        }}
        label={title}
      >
        {children}
      </Select>
    </FormControl>
  );
};